import React, { useContext, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { Box, Unstable_Grid2 as Grid } from "@mui/material";
import Swal from "sweetalert2";
//
import { AuthContext } from "../Auth";
import { getDataPayPalPlus, setSignalDataPayPalPlus } from "../services/Payments/PayPalPlus/getDataPayPalPlus";
// components
import Loader from "../components/Loader";
import SectionLogo from "./sections/PaypalPlus/SectionLogo";
import SectionAddress from "./sections/PaypalPlus/SectionAddress";
import SectionText from "./sections/PaypalPlus/SectionText";
import LineHeader from "./sections/LineHeader";
import DetailsInvoice from "./sections/PaypalPlus/DetailsInvoice";
import CardContainer from "./sections/CardContainer";
import FormPayPalPlus from "./sections/PaypalPlus/FormPayPalPlus";
import ButtonPay from "./sections/PaypalPlus/ButtonPay";
import ImageFooter from "./sections/PaypalPlus/ImageFooter";
import PaymentConfirm from "../components/Checkout/PaymentConfirm";

import { Error500 } from "../alerts/Error";

const PaypalPlus = () => {
  const { invoiceId } = useParams();
  const [loader, setLoader] = useState(false);
  const { userAuth, setShowLoginExpired } = useContext(AuthContext);
  const [detailsPago, setDetailsPago] = useState(null);
  const [disabledButton, setDisabledButton] = useState(false);
  const [successPay, setSuccessPay] = useState(false);
  const payButton = useRef(null);

  const handlerLoaderShow = () => {
    Swal.close();
    setLoader(true);
  };

  const handlerLoaderHide = () => {
    setLoader(false);
  };

  // redirecciona a viewinvoice
  const redirectToErrorView = () => {
    window.location.replace(process.env.REACT_APP_CLIENTES_BASE_URL + "viewinvoice.php?id=" + invoiceId + "&errortransfer=true");
  };

  const handlerSuccessPay = () => {
    setSuccessPay(true);
  };

  useEffect(() => {
    const abortController = new AbortController();
    setSignalDataPayPalPlus(abortController.signal);

    const init = async () => {
      handlerLoaderShow();
      const dataPPP = await getDataPayPalPlus(invoiceId, userAuth?.token, () => {
        handlerLoaderHide();
      });

      // se recibio respuesta
      if (dataPPP) {
        setDetailsPago(null);
        // la respuesta es de error
        if (dataPPP.result === "error") {
          handlerLoaderHide();
          switch (dataPPP.error) {
            case "session":
              setShowLoginExpired(true);
              break;

            default:
              Error500(() => {
                redirectToErrorView();
              });
              break;
          }
        }

        // la respuesta es correcta
        if (dataPPP.result === "success") {
          setDetailsPago(dataPPP.data);

          // si el invoice aparece como pagado
          if (dataPPP.data.status === "paid") {
            handlerSuccessPay();

            //si el invoice tiene un status diferente de 'paid' o 'unpaid'
          } else if (dataPPP.data.status !== "unpaid") {
            redirectToErrorView();
          }
        }
      }
    };

    init();

    return () => {
      abortController.abort();
    };
  }, [invoiceId, userAuth]);

  return (
    <>
      {!successPay && (
        <Box className="cart-content" sx={{ minHeight: "100vh" }}>
          <LineHeader />

          <Loader open={loader} />

          {detailsPago !== null && (
            <CardContainer>
              <SectionLogo />

              <SectionText />

              <SectionAddress address={detailsPago.transactions[0].item_list.shipping_address} />

              <Grid container spacing={0} sx={{ m: 0 }} columnSpacing={{ xs: 0, sm: 4, md: 6 }} rowSpacing={{ xs: 3, sm: 6, md: 3 }}>
                <Grid xs={12} md={6} order={{ xs: 1, md: 2 }}>
                  <DetailsInvoice transaction={detailsPago.transactions[0]} />
                </Grid>

                <Grid xs={12} md={6} order={{ xs: 2, md: 1 }} sx={{ paddingBottom: 0 }}>
                  {/* height={{ xs: "660px", sm: "520px", md: "550px" }} */}
                  {detailsPago !== null && detailsPago.status === "unpaid" && (
                    <FormPayPalPlus
                      detailsPago={detailsPago}
                      refButton={payButton}
                      handlerLoaderShow={handlerLoaderShow}
                      handlerLoaderHide={handlerLoaderHide}
                      setDisabledButton={setDisabledButton}
                    />
                  )}
                </Grid>

                <Grid xs={12} md={6} order={{ xs: 3 }} sx={{ display: "flex", justifyContent: "center", alignItems: "center", padding: 0 }}>
                  <ButtonPay refButton={payButton} id="continueButton" variant="contained" disabled={disabledButton} />
                </Grid>
              </Grid>

              <ImageFooter />
            </CardContainer>
          )}
        </Box>
      )}

      {successPay && detailsPago !== null && (
        <PaymentConfirm confirmCost={"$ " + detailsPago?.transactions[0]?.amount?.total + " " + detailsPago?.transactions[0]?.amount?.currency} />
      )}
    </>
  );
};

export default PaypalPlus;
